<template>
  <div>
    <LDBsTable
      ref="table"
      url="integrator/settings"
      defaultSort="createdAt"
      defaultOrder="desc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions='options'
      :loadOnMount="false"
      startSearchOpen
    >
      <div class="form-group col-lg-12">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :getOptionLabel="client => client.CLI_ID + ' - ' + client.CLI_DSC"
          :options="arenaClients"
          v-model="queryToUse.company"
          :initial-value="queryToUse.company"
          :reduce="client => client.CLI_ID"
        />
      </div>

      <div class="form-group col-lg-12">
        <label for="user">{{ $t('user') }}</label>
        <Combobox
          class="bg-white"
          name='user'
          :placeholder="$t('select_a_item')"
          :getOptionLabel="user => user.id + ' - ' + user.USR_NOM"
          :options="arenaUsers"
          v-model="queryToUse.user"
          :initial-value="queryToUse.user"
          :reduce="user => user.id"
        />
      </div>

      <div class="form-group col-12">
        <label>{{ $t('machine') }}</label>
        <input
          type="text"
          name="machine"
          class="form-control"
          v-model="queryToUse.machineId"
          :placeholder="$t('ph_machine')"
        >
      </div>
    </LDBsTable>
  </div>
</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from 'vuex';

export default {
  name: "Integrator",
  components: {
    LoaderButton,
    Combobox,
    LDBsTable
  },

  data() {
    return {
      clientSelected: null,
      userSelected: null,
      errorsMessage: [],
      machineSelected: undefined,
      currentXMLDirectoriesConfig: {},
      columns: [
        {
          title: this.$t('client'),
          field: 'company',
          sortable: false
        },
        {
          title: this.$t('user'),
          field: 'user',
          sortable: false
        },
        {
          title: this.$t('machine'),
          field: 'machineId',
          sortable: false
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/integrador/integrator/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'integrador-configuracoes' }
      },
      query: {
        company: undefined,
        user: undefined,
        machineId: ''
      },
      queryToUse: {}
    };
  },

  computed: {
    ...mapState({
      arenaClients: state => state.arena.clients,
      arenaUsers: state => state.arena.users,
      origins: state => state.origin.all,
      lastquery: state => state.filtershistory.query
    }),

    canShowForm() {
      return Object.keys(this.integratorSettings).length
    },

    integratorSettings: {
      get() {
        return this.$store.state.integrator.settings;
      },

      set(value) {
        this.$store.commit('integrator/setSettings', value)
      }
    },

    machines() {
      return Object.keys(this.integratorSettings.xmlDirectories);
    },

    xmlDirectories: {
      get() {
        return this.integratorSettings.xmlDirectories[this.machineSelected];
      },

      set(value) {
        this.integratorSettings.xmlDirectories[this.machineSelected] = value;
      }
    },

    breakWindowTime: {
      get() {
        return this.integratorSettings.windowConfig.breakWindow.time / 60;
      },

      set(value) {
        this.integratorSettings.windowConfig.breakWindow.time = value * 60;
      }
    },

    serviceTime: {
      get() {
        const value = this.integratorSettings.windowConfig.serviceTime

        if (this.integratorSettings.windowConfig.serviceTimeType === 'fixed_time') {
          const minutes = value / 60;

          return minutes < 1 ? 1 : minutes;
        }

        return value * 1;
      },
      set(value) {
        this.integratorSettings.windowConfig.serviceTime = this.integratorSettings.windowConfig.serviceTimeType === 'fixed_time'
          ? value * 60
          : value * 1
      },
    },

    moduleConfigValue: {
      get() {
        // Retorna apenas o 'value' do objeto moduleConfig, que é o que o radio group precisa.
        return this.integratorSettings.moduleConfig ? this.integratorSettings.moduleConfig.value : null;
      },
      set(newValue) {
        // Quando um novo rádio é selecionado, `newValue` é o valor primitivo (ex: 'microservice').
        const selectedOption = this.optionsModules.find(opt => opt.value === newValue);

        if (selectedOption) {
          const newSettings = {
            ...this.integratorSettings,
            // Atualiza o objeto moduleConfig no estado com uma cópia da opção selecionada.
            moduleConfig: { ...selectedOption }
          };
          // Usa o setter principal para comitar a alteração para o Vuex.
          this.integratorSettings = newSettings;
        }
      }
    },
  },

  methods: {
    clear() {
      this.query = {
        company: undefined,
        user: undefined,
        machineId: ''
      }
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery['integratorsettingslist'] ? this.lastquery['integratorsettingslist'] : this.query
  },

  async mounted() {
    const { dispatch } = this.$store

    if (this.lastquery['integratorsettingslist']) {
      for (const [key, value] of Object.entries(this.lastquery['integratorsettingslist'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    await Promise.all([
      dispatch('arena/fetchClients'),
      dispatch('arena/fetchArenaUsers')
    ])
  },

  destroyed () {
    this.$store.dispatch('filtershistory/setQuery', { key: 'integratorsettingslist', query: this.query })
  },
};
</script>

<style>
.nav-link {
  color: black !important;
}

.onoffswitch {
  position: relative;
  width: 60px;
  height: 30px; /* define uma altura fixa */
  display: inline-block;
  vertical-align: middle;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #E3E3E3;
  border-radius: 30px;
  height: 100%;
}

.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
  background-color: #ffc107;
  color: white;
  text-align: center;
  line-height: 30px; /* igual à altura */
  font-weight: bold;
}

.onoffswitch-switch {
  display: block;
  width: 30px;
  height: 30px;
  margin: 0;
  background: white;
  position: absolute;
  top: 0;
  right: 30px;
  border: 2px solid #E3E3E3;
  border-radius: 30px;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0;
}

</style>
